<template>
  <div class="products-slider-container py-8">
    <v-layout wrap justify-start class="mb-6 px-2">
      <v-flex xs12 text-left>
        <div class="d-flex align-center">
          <div class="title-indicator mr-3"></div>
          <h2 class="slider-title">{{ name }}</h2>
        </div>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-start>
      <v-flex xs12 pa-0>
        <v-slide-group
          class="custom-slide-group"
          active-class="success"
          show-arrows
        >
          <template v-slot:next>
            <v-btn fab small color="white" class="slider-nav-btn elevation-3">
              <v-icon color="#3EA56E">mdi-chevron-right</v-icon>
            </v-btn>
          </template>
          <template v-slot:prev>
            <v-btn fab small color="white" class="slider-nav-btn elevation-3">
              <v-icon color="#3EA56E">mdi-chevron-left</v-icon>
            </v-btn>
          </template>

          <v-slide-item v-for="(item, i) in products" :key="i">
            <div class="slider-item-wrapper pa-3">
              <ProductsSliderItem
                v-bind:product="item"
                @stepper="winStepper"
                :cardWidth="widthOfCard"
              />
            </div>
          </v-slide-item>
        </v-slide-group>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import ProductsSliderItem from "./productsSliderItem";
export default {
  components: {
    ProductsSliderItem,
  },
  props: ["name", "products"],
  data() {
    return {
      widthOfCard: "240px",
    };
  },
  methods:{
     winStepper(item) {
      if (item.ref == "addtocart") {
         this.$emit("stepper", {
          ref: "addcart",
          productId: item.productId1,
        });
      }
    },
  },
};
</script>

<style scoped>
.products-slider-container {
  background: transparent;
}

.title-indicator {
  width: 5px;
  height: 28px;
  background: linear-gradient(to bottom, #3ea56e, #2d7a52);
  border-radius: 10px;
}

.slider-title {
  font-family: 'ibmsemibold', sans-serif;
  font-size: 26px;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.5px;
}

.custom-slide-group >>> .v-slide-group__prev,
.custom-slide-group >>> .v-slide-group__next {
  min-width: 50px;
  z-index: 5;
}

.slider-nav-btn {
  background-color: white !important;
  border: 1px solid #f0f0f0 !important;
  transition: all 0.2s ease;
}

.slider-nav-btn:hover {
  background-color: #3ea56e !important;
}

.slider-nav-btn:hover .v-icon {
  color: white !important;
}

.slider-item-wrapper {
  transition: transform 0.3s ease;
}

.slider-item-wrapper:hover {
  transform: translateY(-5px);
}
</style>